export function parseClipboardGrid(text: string): string[][] {
  const lines = text.replace(/\r/g, "").split("\n");
  if (lines.length > 1 && lines[lines.length - 1] === "") lines.pop();
  return lines.map((line) => line.split("\t").map((cell) => cell.trim()));
}

export function flattenClipboardGrid(grid: string[][]): string[] {
  return grid.flat();
}
